import { apiClient } from "rp-components"
import { ResourceLink } from "rp-components"
import Compressor from "compressorjs"

export interface FileService {
    uploadPublicFile(file: File): Promise<ResourceLink>
    uploadMaintenanceFile(file: File): Promise<ResourceLink>
    uploadGuestInviteFile(file: File): Promise<ResourceLink>
    compressFile(file: File): Promise<File>
}

class FileServiceImpl implements FileService {
    static instance?: FileService = undefined

    private constructor() {}

    static getInstance(): FileService {
        if (FileServiceImpl.instance == undefined) {
            FileServiceImpl.instance = new FileServiceImpl()
        }
        return FileServiceImpl.instance
    }

    async uploadPublicFile(file: File): Promise<ResourceLink> {
        const data = new FormData()
        data.append("file", file)
        return apiClient.upload<ResourceLink>(`/files/public`, data)
    }

    async uploadMaintenanceFile(file: File): Promise<ResourceLink> {
        const data = new FormData()
        data.append("file", file)
        return apiClient.upload<ResourceLink>(`/files/maintenance`, data)
    }

    async uploadGuestInviteFile(file: File): Promise<ResourceLink> {
        const data = new FormData()
        data.append("file", file)
        return apiClient.upload<ResourceLink>(`/files/guests`, data)
    }

    async compressFile(file: File): Promise<File> {
        const compression: Promise<File> = new Promise((resolve) => {
            new Compressor(file, {
                quality: 0.6,
                success(result) {
                    resolve(result as File)
                },
                error() {
                    resolve(file)
                }
            })
        })
        return await compression
    }
}

export default FileServiceImpl.getInstance()
